import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../contexts/LanguageContext";
import { useAuth } from "../contexts/AuthContext";
import { ReptileCard } from "../components/ReptileCard";
import { ProductCard } from "../components/ProductCard";
import { useCart } from "../contexts/CartContext";

const Wishlist = () => {
  const { t } = useLang();
  const { user, signIn } = useAuth();
  const { addItem } = useCart();
  const [items, setItems] = useState([]);
  const [reptiles, setReptiles] = useState([]);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (!user) return;
    api.get("/wishlist").then(async (r) => {
      setItems(r.data);
      const repIds = r.data.filter((i) => i.item_type === "reptile").map((i) => i.item_id);
      const prodIds = r.data.filter((i) => i.item_type === "product").map((i) => i.item_id);
      const reps = await Promise.all(repIds.map((id) => api.get(`/reptiles/${id}`).then((x) => x.data).catch(() => null)));
      const prods = await Promise.all(prodIds.map((id) => api.get(`/products/${id}`).then((x) => x.data).catch(() => null)));
      setReptiles(reps.filter(Boolean));
      setProducts(prods.filter(Boolean));
    });
  }, [user]);

  return (
    <div data-testid="wishlist-page" className="bg-[var(--monzal-bg)] min-h-screen">
      <div className="border-b border-white/5">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16">
          <div className="overline">WISHLIST</div>
          <h1 className="font-display font-light text-4xl lg:text-6xl text-white tracking-tight mt-4">{t("nav.wishlist")}</h1>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-12">
        {!user ? (
          <div className="text-center py-24">
            <Heart size={48} className="text-[var(--monzal-gold)]/40 mx-auto" />
            <p className="text-gray-400 mt-6">{t("auth.welcomeSub")}</p>
            <button onClick={signIn} className="btn-gold mt-8" data-testid="wishlist-signin">{t("auth.signIn")}</button>
          </div>
        ) : items.length === 0 ? (
          <div className="text-center py-24" data-testid="wishlist-empty">
            <p className="text-gray-400">{t("market.noResults")}</p>
            <Link to="/marketplace" className="btn-gold inline-flex mt-8">{t("cart.exploreCta")}</Link>
          </div>
        ) : (
          <div className="space-y-12">
            {reptiles.length > 0 && (
              <div>
                <div className="overline mb-5">{t("nav.marketplace")}</div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                  {reptiles.map((r) => <ReptileCard key={r.id} reptile={r} testIdPrefix="wishlist-rep" />)}
                </div>
              </div>
            )}
            {products.length > 0 && (
              <div>
                <div className="overline mb-5">{t("nav.shop")}</div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                  {products.map((p) => <ProductCard key={p.id} product={p} onAdd={(prod) => addItem({ item_id: prod.id, item_type: "product", title: prod.title, cover: prod.cover, price: prod.price })} testIdPrefix="wishlist-prd" />)}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Wishlist;
